import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DraggableListItem from './draggableListItem';
import { v4 as uuidv4 } from 'uuid';

const DraggableList = React.memo(
  ({ items, onDragEnd, actionItems, labelKey, actionOnHover, showSecondaryText }) => {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-list">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => (
                <DraggableListItem
                  item={item}
                  index={index}
                  key={`${uuidv4()}-index`}
                  actionItems={actionItems}
                  labelKey={labelKey}
                  actionOnHover={actionOnHover}
                  showSecondaryText={showSecondaryText}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  },
);

DraggableList.propTypes = {
  items: PropTypes.array.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  actionItems: PropTypes.func,
  labelKey: PropTypes.string,
  actionOnHover: PropTypes.bool,
  showSecondaryText: PropTypes.bool,
};

DraggableList.defaultProps = {
  showSecondaryText: false
}

export default DraggableList;
